export default "__VITE_ASSET__yDJgP6rA__"